

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	DxToolbarItem
} from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import { Panel } from '@/components';
import { configuration } from '@/configuration';

import ChartsListPanelItem from './charts-list-panel-item.vue';
import { apiService, customerService } from '@/container';

@Component({
	components: {
		ChartsListPanelItem,
		DxScrollView,
		DxToolbarItem,
		Panel
	}
})
export default class ChartsListPanel extends Vue {

	@Prop({ type: Boolean, default: false }) showPanel!: boolean | null;
	@Prop({ type: String, required: true }) idDashboard!: string;


	availableCompanies: ICompanyItem[] = [];
	internalShowPanel = false;

	myChartsList: Array<{
		id: string;
		name: string
	}> = [];
	sharedWithMeChartsList: Array<{
		id: string;
		idChart: string;
		name: string
	}> = [];

	async mounted() {
		await this.loadMyChartsList();
		await this.loadSharedChartsList();
	}

	get closeButtonProps() {
		return {
			location: 'after',
			options: {
				class: 'mr-2',
				icon: 'far fa-times',
				onClick: this.onCloseClick,
				stylingMode: 'outlined',
				text: this.$t('dashboard.close'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	async loadMyChartsList() {
		const charts = await apiService.post('charts', 'notAssignedToDashboard', { idDashboard: this.idDashboard, idCustomer: customerService.getCustomer() });
		this.myChartsList = charts;
	}

	async loadSharedChartsList() {
		const availableCompanies = await apiService.post<ICompanyItem[]>('company', 'companiesByCustomer', { idCustomer: customerService.getCustomer() }, {
			axiosConfig: {
				baseURL: configuration.authBackendBaseUrl
			}
		});

		const charts = await apiService.post('charts', 'getNotSharedWithCurrentDashboard', { idDashboard: this.idDashboard, idCustomer: customerService.getCustomer(), companies: availableCompanies });
		// const b = await apiService.post('charts', 'sharedSelection', { idCustomer: customerService.getCustomer(), companies: availableCompanies });

		this.sharedWithMeChartsList = charts;
	}

	async reload() {
		await this.loadMyChartsList();
	}

	async reloadShared() {
		await this.loadSharedChartsList();
	}

	onCloseClick() {
		this.internalShowPanel = false;
	}

	@Watch('showPanel', { immediate: true })
	onShowPopupChange(newValue: boolean) {
		this.internalShowPanel = newValue;
	}

	@Watch('internalShowPanel')
	onInternalShowPopupChange(newValue: boolean) {
		this.$emit('update:show-panel', newValue);
	}

}
interface ICompanyItem {
	Id: string;
	BusinessName: string;
}
